<template>
    <v-layout class="justify-center">
        <v-flex xs12 sm12 md10>
            <v-stepper v-model="step">
                <v-stepper-header>
                    <v-stepper-step :complete="step > 1" step="1"
                        >Message Content</v-stepper-step
                    >
                    <v-divider />
                    <v-stepper-step :complete="step > 2" step="2"
                        >Recipients</v-stepper-step
                    >
                    <v-divider />
                    <v-stepper-step step="3">Confirm</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-card>
                            <v-card-title>
                                <span class="headline">Message Content</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12 sm6 md4>
                                            <v-text-field
                                                v-model="newMessage.subject"
                                                label="Subject"
                                                outlined
                                            />
                                        </v-flex>
                                        <v-flex xs12 sm6 md4>
                                            <v-select
                                                v-model="newMessage.messageType"
                                                :items="messageTypes"
                                                item-text="messageType"
                                                item-value="uid"
                                                label="Message Type"
                                                return-object
                                                outlined
                                            />
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-textarea
                                                v-model="newMessage.message"
                                                label="Message"
                                                outlined
                                            />
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="error" @click="cancel"
                                    >Cancel</v-btn
                                >
                                <v-btn color="primary" @click="step = 2"
                                    >Continue</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <v-card>
                            <v-card-title>
                                <span class="headline">Recipients</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12 sm6 md4>
                                            <v-select
                                                v-model="
                                                    newMessage.messageGroup
                                                "
                                                :items="messageGroups"
                                                item-text="messageGroup"
                                                item-value="uid"
                                                label="Message Group"
                                                return-object
                                                outlined
                                            />
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="warning" @click="step = 1"
                                    >Previous</v-btn
                                >
                                <v-btn color="primary" @click="step = 3"
                                    >Continue</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <v-card>
                            <v-card-title>
                                <span class="headline">Confirm</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12 sm6 md4>
                                            <v-label
                                                >Subject:
                                                {{
                                                    newMessage.subject
                                                }}</v-label
                                            >
                                        </v-flex>
                                        <v-flex xs12 sm6 md4>
                                            <v-label
                                                >Message Type:
                                                {{
                                                    newMessage.messageType
                                                        .messageType
                                                }}</v-label
                                            >
                                        </v-flex>
                                        <v-flex xs12 sm6 md4>
                                            <v-label
                                                >Recipients:
                                                {{
                                                    newMessage.messageGroup
                                                        .messageGroup
                                                }}</v-label
                                            >
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-label
                                                >Message:
                                                {{
                                                    newMessage.message
                                                }}</v-label
                                            >
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="warning" @click="step = 2"
                                >Previous</v-btn
                                >
                                <v-btn color="primary" @click="create"
                                    >Create</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: 'MessageCreate',
    data() {
        return {
            step: 1,
            newMessage: {
                user: '',
                subject: '',
                message: '',
                messageType: { uid: '', messageType: '' },
                messageGroup: { uid: '', messageGroup: '' }
            },
            default: {
                user: '',
                subject: '',
                message: '',
                messageType: { uid: '', messageType: '' },
                messageGroup: { uid: '', messageGroup: '' }
            }
        };
    },
    computed: {
        messageTypes() {
            return this.$store.state.messageTypes;
        },
        messageGroups() {
            return this.$store.state.messageGroups;
        },
        currentUser() {
            return this.$store.state.user;
        }
    },
    mounted() {
        this.initialize();
    },
    methods: {
        initialize() {
            this.getMessages();
            this.getMessageTypes();
            this.getMessageGroups();
            this.newMessage.user = this.currentUser.fbUser.displayName;
            this.default.user = this.currentUser.fbUser.displayName;
        },

        getMessages() {
            this.$store.dispatch('messageRead');
        },

        getMessageTypes() {
            this.$store.dispatch('messageTypeRead');
        },

        getMessageGroups() {
            this.$store.dispatch('messageGroupRead');
        },

        create() {
            this.$store.dispatch('messageCreate', {
                formData: this.newMessage
            });
            this.reset();
        },

        cancel() {
            this.newMessage = Object.assign({}, this.default);
            this.step = 1;
        },

        reset() {
            setTimeout(() => {
                this.newMessage = Object.assign({}, this.default);
                this.step = 1;
            }, 1000);
        }
    }
};
</script>

<style scoped />
